export const wholeNumber = (value) => {
  if (typeof value === 'string') {
    return value.includes('.') ? parseInt(parseFloat(value).toFixed(2).replace('.', '')) : parseInt(value);
  } else if (typeof value === 'number' && value.toString().includes('.')) {
    return parseInt(value.toString().replace('.', ''));
  } else {
    return value;
  }
}

export const money = (value, currencySymbol = '$') => {
  return `${currencySymbol}${(value / 100).toFixed(2)}`;
}